import { Component, Input, SimpleChanges } from '@angular/core';
import { BatteryTypeOption, toBatteryTypeSeries } from 'src/app/_shared/utils/battery-type';
import { TransformXAxisPipe } from 'src/app/_shared/pipes/transform-xaxis.pipe';
import { createPlotlyChart } from 'src/app/_shared/plotlyConfig';

@Component({
  selector: 'app-soc-events-low',
  templateUrl: './soc-events-low.component.html',
  styleUrls: ['./soc-events-low.component.scss']
})
export class SocEventsLowComponent {
  @Input() fleetId: string[] = [];
  @Input() selectedBatteryTypes: BatteryTypeOption[] = [];
  @Input() dataLoadingSocEvents!: boolean;
  @Input() errorMessageSocEvents!: boolean;
  @Input() stateOfChargeEventsDatapoints!: any;
  chartRange!: { range: [number, number]; };
  
  ngOnChanges(changes: SimpleChanges): void {
    if (Object.keys(this.stateOfChargeEventsDatapoints).length !== 0) {
      this.plotSocEventsLow();
    }
  }
  
  plotSocEventsLow() {
    const transformXAxisPipe = new TransformXAxisPipe();

    const data = toBatteryTypeSeries(this.stateOfChargeEventsDatapoints, this.selectedBatteryTypes).map((series) => {
      const filteredData = series.datapoints.filter((dataObject: any) => dataObject.lowSocEvents !== null);
      return {
        x: filteredData.map((dataObject: any) => dataObject.binSocEvents),
        y: filteredData.map((dataObject: any) => dataObject.lowSocEvents),
        type: 'bar',
        name: series.label,
        marker: {
          color: series.color
        }
      };
    });

    const lowSoc = data.flatMap((trace) => trace.x);
    const percentAmount = data.flatMap((trace) => trace.y);

    if (percentAmount.length === 0) {
      this.errorMessageSocEvents = true;
      return;
    } else {
      this.errorMessageSocEvents = false;
    }

    this.chartRange = transformXAxisPipe.transform(lowSoc, percentAmount, 5, 100);

    const layout = {
      title: 'Low State of Charge Events',
      font: {
        family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
        size: 13,
      },
      barmode: 'group',
      xaxis: {
        title: 'Number of low State of Charge events',
        range: this.chartRange?.range
      },
      yaxis: {
        title: 'Percentage of Fleet Vehicles [%]'
      },
      showlegend: true,
      legend: {
        orientation: 'h', 
        y: -0.3, 
        xanchor: 'center', 
        x: 0.5,
        font: {
          family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
          size: 13,
        },
      }
    };
    createPlotlyChart('soc-events-low', data, layout);
  }
}